import axios from 'axios';
import React, { useState } from 'react';

const FetchScatrResultsButton = () => {
  const [status, setStatus] = useState("Load Scatr Results");
  const loadScatrResults = async () => {
    try {
      setStatus("Loading...");
      const res = await axios.get("/client_visits/fetch_scatr_results.json");
      if (res.status !== 200) setStatus("error");
      else setStatus("Loaded Successfully");
    } catch(err) {
      setStatus("Error");
    }
  }
  
  return (
    <button className='button is-primary is-pulled-right' style={{marginBottom: "auto", marginTop: "auto"}} onClick={loadScatrResults}>{status}</button>
  )
}

export default FetchScatrResultsButton;